import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import {Card, Grid, CardActionArea, Skeleton, Typography, Grow } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';


const MovieCard = ({item}) =>{
  let type = item.original_name == null ? 'movie':'tv';
  const Stamp = styled('p')(({ theme }) => ({
    backgroundColor:"#3030308c",
    color:"#fff",
    padding:"1px",
    width:"4rem",
    textAlign:"center",
    position:"absolute",
    bottom:"-3.5%",
    right:"0",
    fontSize:"1rem",
    borderTopLeftRadius:"4px",
    borderBottomLeftRadius:"4px",
  }));


    return(
      <>
      {item ?
        <Link to={`/fullDescription/${type}/${item.id}`} style={{textDecoration:'none'}}>
        <Grid item className='custom-card'>
        <Card sx={{ maxWidth: 350, borderRadius:"18px", backgroundColor:"#fff0"}}>
        <CardActionArea sx={{height:'25rem',borderRardius:"15px",backgroundColor:"#2d2d2d",backgroundImage:`url(https://image.tmdb.org/t/p/w300/${item.poster_path})`, backgroundSize:"cover", backgroundPosition:"center"}}>
        <Stamp>
          {type =='tv'?
          <span>Série</span>:<span>Filme</span>  
        }
        </Stamp>
        </CardActionArea>
      </Card>
      </Grid>
      </Link>
      :
      <>
      </>
      }
      </>
    
    );
}

export default MovieCard


